import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_secured/taxonomy')({
  async loader({ context }) {
    await context.getInstance('i18n', '@mint-admin/secured-taxonomy-mdm');
    await context.getInstance('i18n', '@mint-lib/mdm');
    await context.getInstance('i18n', '@mint-lib/formatting-hooks');
    await context.getInstance('i18n', '@mint-lib/tw-components');
  },
});
